import { Component, OnInit, Output, EventEmitter, HostListener } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UserService } from '../../users/user.service';
import { ProcessorCloserReassignmentService } from '../processor-closer-reassignment.service';
import { User } from '../../users/user.model';
import { ReassignmentBaseDto } from '../reassignment';
import { MatDialog } from '@angular/material';
import { UwReshuffleDialogComponent } from '../../uw-reshuffle-dialog/uw-reshuffle-dialog.component';

@Component({
  selector: 'app-processor-reassignment',
  templateUrl: './processor-reassignment.component.html',
  styleUrls: ['./processor-reassignment.component.css']
})
export class ProcessorReassignmentComponent implements OnInit {
    @Output() pendingLoanCount = new EventEmitter<any>();

    public processorReshuffleForm: FormGroup;
    public currentProcessors: User[] = [];
    public activeProcessors: User[] = [];
    public allCurrentProcessor = [];
    public allActiveProcessor = [];
    public currentLoanOfficers: User[] = [];
    public activeLoanOfficers: User[] = [];
    public allCurrentLoanOfficer = [];
    public allActiveLoanOfficer = [];
    public loans: any[];
    public showNewProcessor = false;
    public showButton = false;
    public searchNewUser: string = null;
    public searchCurrentUser: string = null;
    public selectedActiveProcessor: User[] = [];
    public selectedCurrentProcessor: User;
    public isLoading = false;
    public inputMessage = "";
    public unassignedLoans = [];
    public assignments = [];

    public loanList = [];
    public allLoanList = [];
    public selectedLoans = [];
    public filteredLoans = [];
    public tempLoanList = [];
    public isSortedByLoan = false;
    public isSortedByMilestone = false
    public isSortedByUser = false;
    public isSortedByLoanOfficer = false;
    public loanCount = 0;
    public isAllSelected = false;
    public searchControl = new FormControl();
    public searchByControl = new FormControl();
    public isCheckedControl = new FormControl();


    public searchColumns = [
        { name: 'Loan Number', value: 'loanNumber' },
        { name: 'Last Completed Milestone', value: 'lastCompletedMilestone' },
        { name: 'Current Processor', value: 'user' },
        { name: 'Loan Officer', value: 'loanOfficer' }
    ]

    @Output() close: EventEmitter<any> = new EventEmitter();

    constructor(private fb: FormBuilder,
        public userService: UserService,
        private dialog: MatDialog,
        private processorCloserReassignementService: ProcessorCloserReassignmentService) {
        this.createForm();
    }

    async ngOnInit() {
        await this.getCurrentAndActiveUsers();

        this.processorReshuffleForm.get("isCheckedControl").setValue(false);
        this.isAllSelected = false;
        this.selectedLoans = [];
        this.filteredLoans = [];
        this.tempLoanList = [];
    }

    createForm() {
        this.processorReshuffleForm = this.fb.group({
            currentProcessor: [null, Validators.required],
            newProcessor: [null, Validators.required],
            searchLoan: this.fb.group({
                searchControl: [null],
                searchByControl: [null]
            }),
            pendingLoanCountControl: [null],
            isCheckedControl: [null]
        });
    }

    async getCurrentAndActiveUsers() {
        try {
            this.isLoading = true;
            this.inputMessage = "Fetching Processors..";
            let allProcessorUsers = await this.processorCloserReassignementService.getHistoricalProcessorUsers();
            if (allProcessorUsers.length == 0) {
                this.showMessage("No Processor Loans are available for Reassignment.", null, null);
            }
            this.currentProcessors = [...allProcessorUsers];
            this.allCurrentProcessor = [...allProcessorUsers];
            let users = await this.userService.getUsersByPersona('Processor');
            this.activeProcessors = [...users];
            this.activeProcessors.sort((a, b) => (a.firstName + ' ' + a.lastName).localeCompare(b.firstName + ' ' + b.lastName));

            this.allActiveProcessor = [...users];
            this.allActiveProcessor.sort((a, b) => (a.firstName + ' ' + a.lastName).localeCompare(b.firstName + ' ' + b.lastName));

            this.isLoading = false;
        }
        catch (ex) {
            console.log(ex);
            this.isLoading = false;
        }
    }

    onSelectionChange(event, flag) {
        if (flag == 'current') {
            this.searchCurrentUser = null;
            this.selectedCurrentProcessor = event.value;
            this.getCurrentProcessorsLoans();
            if (this.selectedCurrentProcessor == null) {
                this.processorReshuffleForm.controls['newProcessor'].setValue(null);
            }
        }
        else {
            this.showButton = event.value.length > 0 ? true : false;
            if (event.value.length > 0) {
                event.value.forEach(val => {
                    if (!this.selectedActiveProcessor.includes(val)) {
                        this.selectedActiveProcessor.push(val);
                    }
                })
                let tempUsers = [...this.selectedActiveProcessor];
                tempUsers.forEach((val, index) => {
                    if (!event.value.includes(val)) {
                        this.selectedActiveProcessor.splice(index, 1);
                    }
                })
            }
            else {
                this.selectedActiveProcessor = [];
            }
        }
    }

    async getCurrentProcessorsLoans() {
        this.isLoading = true;
        await this.processorCloserReassignementService.getCollectionOfLoansbyUserAndPersona(this.selectedCurrentProcessor, 'Processor').then(
            loans => {
                if (loans != null && loans != undefined) {
                    if (loans.length > 0) {
                        this.loanList = JSON.parse(JSON.stringify(loans));
                        this.loanList.forEach(loan => {
                            loan.isChecked = false;
                        })
                        this.allLoanList = JSON.parse(JSON.stringify(loans));
                        this.allLoanList.forEach(loan => {
                            loan.isChecked = false;
                        })
                    }
                }
                this.isLoading = false;
            }).catch(error => {
                console.log(error)
                this.isLoading = false;
            });
    }


    onSearchChange(event) {
        if (this.searchNewUser) {
            this.activeProcessors = this.allActiveProcessor.filter(value => value.name.toLowerCase().includes(this.searchNewUser.toLowerCase()));
            this.selectedActiveProcessor.forEach(value => {
                if (!this.activeProcessors.includes(value)) {
                    this.activeProcessors.push(value)
                }
            });
        }
        else {
            this.activeProcessors = [...this.allActiveProcessor];
        }
    }

    onCurrentUserSearch(event) {
        if (this.searchCurrentUser) {
            this.currentProcessors = this.allCurrentProcessor.filter(value => value.name.toLowerCase().includes(this.searchCurrentUser.toLowerCase()));
        }
        else {
            this.currentProcessors = [... this.allCurrentProcessor];
        }
    }

    async onSubmit() {
        if (!this.processorReshuffleForm.valid) {
            return;
        }

        this.isLoading = true;
        this.inputMessage = "Processing reassignment, please wait...";
        try {
            let loans = this.selectedLoans;
            let result = await this.makeReassignment(loans);
        }
        catch (ex) {
            console.log(ex);
            this.isLoading = false;
        }
        this.isLoading = false;
        this.inputMessage = "";
    }

    async makeReassignment(loans) {
        try {
            for (let loan of loans) {
                this.inputMessage = "Reassigning Loan Number " + loan.pipelineLoanDto.fields["Fields.364"];
                console.log(this.inputMessage);
                var reshuffleDto: ReassignmentBaseDto = new ReassignmentBaseDto();
                reshuffleDto.Users = [];
                reshuffleDto.Users = this.selectedActiveProcessor;
                reshuffleDto.PipelineLoanDtos = [];
                reshuffleDto.PipelineLoanDtos.push(loan.pipelineLoanDto);
                reshuffleDto.UserLoanAssignmentDtos = [];
                reshuffleDto.UserLoanAssignmentDtos.push(loan.userLoanAssignmentDto);
                let assignmentResult = await this.processorCloserReassignementService.makeProcessorReassignment(reshuffleDto);
                if (!assignmentResult.assignedSuccessfully) {
                    this.unassignedLoans.push(loan.pipelineLoanDto.fields["Fields.364"]);
                }
                else {
                    this.assignments.push(assignmentResult.messages[0]);
                }
            }
            this.finalizeResult();
        }
        catch (ex) {
            console.log(ex);
            this.showMessage(ex, null, null);
        }
    }

    async finalizeResult() {
        this.processorReshuffleForm.reset();
        this.selectedActiveProcessor = [];
        this.selectedCurrentProcessor = null;
        this.showButton = false;
        var message = "Processor reassignment is complete. See below for a list of loans that did get assigned and those that did not."
        this.showMessage(message, this.assignments, this.unassignedLoans);
    }

    showMessage(message, assignedLoanList, unAssignedLoanList) {
        var dialogData = [{ "message": message, "LoanList": unAssignedLoanList, "AssignedLoanList": assignedLoanList }];

        let dialogRef = this.dialog.open(UwReshuffleDialogComponent, {
            width: "400px", height: "auto",
            data: dialogData,
        });
        dialogRef.afterClosed().subscribe(result => {
            this.close.emit();
        });

    }

    onDropDownOpen() {
        this.searchCurrentUser = null;
        this.searchNewUser = null;
        this.activeProcessors = [... this.allActiveProcessor];
        this.currentProcessors = [... this.allCurrentProcessor];
    }

    selectLoan(loan: any) {
        if (this.selectedLoans.length != 0) {
            var loanIndex = this.selectedLoans.findIndex(element => { return (element.loanNumber == loan.loanNumber); });
            if (loanIndex != -1) {
                this.getSelectedLoansUnchecked(loan);
                this.selectedLoans.splice(loanIndex, 1);
            }
            else {
                this.selectedLoans.push(loan);
                this.getSelectedLoansChecked();
            }
        }
        else {
            this.selectedLoans.push(loan);
            this.getSelectedLoansChecked();
        }
        this.checkSelectAllLoansCheckbox();
    }


    checkSelectAllLoansCheckbox() {
        var isAllChecked = this.isAllLoansSelected();
        var checkbox = this.processorReshuffleForm.get("isCheckedControl");
        checkbox.setValue(isAllChecked);
        this.isAllSelected = isAllChecked;
    }

    getSelectedLoansChecked() {
        if (this.selectedLoans.length != 0) {
            this.selectedLoans.forEach(loan => {
                var index = this.loanList.findIndex(element => { return (element.loanNumber == loan.loanNumber); });
                if (index != null && index != -1) {
                    this.loanList[index].isChecked = true;
                    index = this.allLoanList.findIndex(element => { return (element.loanNumber == loan.loanNumber); });
                    if (index != null && index != -1) {
                        this.allLoanList[index].isChecked = true;
                    }
                }
            });
        }
    }

    getSelectedLoansUnchecked(loan: any) {
        if (this.selectedLoans.length != 0) {
            var index = this.loanList.findIndex(element => { return (element.loanNumber == loan.loanNumber); });
            if (index != null && index != -1) {
                this.loanList[index].isChecked = false;
                index = this.allLoanList.findIndex(element => { return (element.loanNumber == loan.loanNumber); });
                if (index != null && index != -1) {
                    this.allLoanList[index].isChecked = false;
                }
            }
        }
    }

    isAllLoansSelected = (): boolean => {
        var isAllChecked = false;
        if (this.loanList.length == this.allLoanList.length) {
            for (var i = 0; i < this.allLoanList.length; i++) {
                if (this.allLoanList[i].isChecked) {
                    isAllChecked = true;
                }
                else {
                    isAllChecked = false;
                    break;
                }
            }
        }
        else {
            for (var i = 0; i < this.loanList.length; i++) {
                if (this.loanList[i].isChecked) {
                    isAllChecked = true;
                }
                else {
                    isAllChecked = false;
                    break;
                }
            }
        }
        return isAllChecked;
    }

    sortByLoan() {
        if (!this.isSortedByLoan) {
            this.isSortedByLoan = true;
            this.isSortedByUser = false;
            this.isSortedByLoanOfficer = false;
            this.isSortedByMilestone = false;
            this.loanList.sort((a, b) => a.loanNumber.localeCompare(b.loanNumber));
        } else {
            this.isSortedByLoan = false;
            this.loanList.sort((a, b) => a.loanNumber.localeCompare(b.loanNumber)).reverse();
        }

    }

    sortByMilestone() {
        if (!this.isSortedByMilestone) {
            this.isSortedByMilestone = true;
            this.isSortedByUser = false;
            this.isSortedByLoan = false;
            this.isSortedByLoanOfficer = false;
            this.loanList.sort((a, b) => a.lastCompletedMilestone.localeCompare(b.lastCompletedMilestone));
        } else {
            this.isSortedByMilestone = false
            this.loanList.sort((a, b) => a.lastCompletedMilestone.localeCompare(b.lastCompletedMilestone)).reverse();
        }

    }

    sortByUser() {
        if (!this.isSortedByUser) {
            this.isSortedByUser = true;
            this.isSortedByLoan = false;
            this.isSortedByLoanOfficer = false;
            this.isSortedByMilestone = false;
            this.loanList.sort((a, b) => a.firstName.localeCompare(b.firstName));
        } else {
            this.isSortedByUser = false;
            this.loanList.sort((a, b) => a.firstName.localeCompare(b.firstName)).reverse();
        }
    }

    sortByLoanOfficer() {
        if (!this.isSortedByLoanOfficer) {
            this.isSortedByLoanOfficer = true;
            this.isSortedByLoan = false;
            this.isSortedByUser = false;
            this.isSortedByMilestone = false;
            this.loanList.sort((a, b) => a.loanOfficer.localeCompare(b.loanOfficer));
        } else {
            this.isSortedByLoanOfficer = false;
            this.loanList.sort((a, b) => a.loanOfficer.localeCompare(b.loanOfficer)).reverse();
        }
    }


    searchTable() {
        if (this.tempLoanList.length > 0) {
            this.loanList = JSON.parse(JSON.stringify(this.tempLoanList));
            this.filteredLoans.length = 0;
        }
        var searchLoanFormGroup = this.processorReshuffleForm.controls.searchLoan;
        var searchByControl = searchLoanFormGroup.get("searchByControl").value;
        var searchControl = searchLoanFormGroup.get("searchControl").value;
        if (this.filteredLoans.length == 0) {
            if (searchByControl == null || searchControl == null) {
                return;
            }
            if (searchByControl == 'user') {
                this.filteredLoans = this.loanList.filter(element =>
                    (element['firstName'] + ' ' + element['lastName']).toUpperCase().includes(searchControl.toUpperCase())
                );
            }
            else if (searchByControl == 'loanOfficer') {
                this.filteredLoans = this.loanList.filter(element =>
                    element['loanOfficer'].toUpperCase().includes(searchControl.toUpperCase())
                );
            }
            else if (searchByControl == 'loanNumber') {
                this.filteredLoans = this.loanList.filter(element =>
                    element[searchByControl].toUpperCase().includes(searchControl.toUpperCase())
                );
            }
            else {
                this.filteredLoans = this.loanList.filter(element =>
                    element[searchByControl].toUpperCase().includes(searchControl.toUpperCase())
                );
            }
            this.tempLoanList = JSON.parse(JSON.stringify(this.loanList));
            this.loanList = [];
            this.loanList = JSON.parse(JSON.stringify(this.filteredLoans));
        }
        var checkbox = this.processorReshuffleForm.get("isCheckedControl");
        checkbox.setValue(false);
        this.isAllSelected = false;
        this.getSelectedLoansChecked();
        this.checkSelectAllLoansCheckbox();
    }

    selectAll() {

        if (this.loanList.length > 0) {
            if (this.isAllSelected == false) {
                this.loanList.forEach(loan => {
                    loan.isChecked = true;
                });
                this.isAllSelected = true;
                if (this.selectedLoans != null && this.selectedLoans.length > 0) {
                    this.loanList.forEach(loan => {
                        var loanIndex = this.selectedLoans.findIndex(element => { return (element.loanNumber == loan.loanNumber); });
                        if (loanIndex != null && loanIndex == -1) {
                            this.selectedLoans.push(loan);
                        }
                    });
                }
                else {
                    this.selectedLoans = JSON.parse(JSON.stringify(this.loanList));
                }
            }
            else {
                this.loanList.forEach(loan => {
                    loan.isChecked = false;
                    if (this.allLoanList.length > 0) {
                        this.allLoanList.forEach(element => {
                            if (element.loanNumber === loan.loanNumber) {
                                element.isChecked = false;
                            }
                        })
                    }
                });
                this.isAllSelected = false;
                this.selectedLoans = [];
            }
        }
    }



}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/processor-closer-pipeline-reassignment/processor-reassignment/processor-reassignment.component.ts